// 安心安全メールの過去一覧ページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import axios from 'axios';
/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';
import SendTableRow from '../components/SendTableRow';
/*-------------------
    cssのimport
---------------------*/
import '../css/safety.css';
import { API_PATH } from '../constant/constant';

// クラス名
class BackNumber extends Component {
  constructor(props) {
    super(props);

    // URLから安心安全メールのコードを取得。
    const url = props.location.pathname;
    const num = url.lastIndexOf('/');
    const cryptUrl = url.slice(num + 1);
    this.state = { cryptUrl, dispSkip: 0, srcTitle: '', srcStDate: '', srcEdDate: '' };
  }

  componentDidMount = async () => {
    const { cryptUrl } = this.state;

    // サイト情報を取得する。
    const resData = await commons.siteSetting(cryptUrl);
    const { setting, footer } = resData;

    if (setting === true) return;
    if (setting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const { site_info: siteInfo, lcl_gov: lclGov } = setting[0];
    const { lg_cd: lgCd = '' } = lclGov;
    const { name: siteName = '', disp_num_user: dispNumUser = '' } = siteInfo;

    // アカウント情報を取得する。
    const accountSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_ACCOUNT',
      kind: '2',
    });
    const { insert_code: insertCode, account_info: accountInfo } = accountSetting[0];
    document.title = `${siteName}`;

    // グループ情報を取得する。
    const groupSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_GROUP',
      kind: '2',
    });
    const { group_info: groupInfo = [] } = groupSetting[0] || '';

    // メール配信情報を取得する。
    const resMailData = await this.getData(
      0,
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      '',
      '',
      groupInfo
    );

    this.setState({
      lgCd,
      footer,
      dispNumUser,
      siteName,
      insertCode,
      accountInfo,
      ...resMailData,
      groupChoice: '',
      groupInfo,
    });
  };

  // 選択したグループのメール配信情報を、現在の件名・日付の入力内容を保持したまま取得する。
  changeGroup = async (id) => {
    const {
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      groupInfo,
      srcTitle,
      srcStDate,
      srcEdDate,
    } = this.state;

    const srcObj = { srcTitle, srcStDate, srcEdDate };
    // メール配信情報を取得する。
    const resMailData = await this.getData(
      0,
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      srcObj,
      id,
      groupInfo
    );
    this.setState({
      dispSkip: 0,
      groupChoice: id,
      ...resMailData,
      srcObj,
    });
  };

  // 検索条件(件名・日付・グループ)をクリアして再検索する。
  clearData = async () => {
    const { dispNumUser, lgCd, insertCode, accountInfo, groupInfo } = this.state;

    const srcObj = { srcTitle: '', srcStDate: '', srcEdDate: '' };
    const resData = await this.getData(
      0,
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      srcObj,
      '',
      groupInfo
    );
    this.setState({
      dispSkip: 0,
      groupChoice: '',
      srcTitle: '',
      srcStDate: '',
      srcEdDate: '',
      srcObj,
      ...resData,
      clearKey: commons.randomNum(),
    });
  };

  // グループの選択欄を作成する。選択中のボタンに selected クラスを付与する。
  createGroupContent = (groupInfo, groupChoice) => {
    const groupContent = [
      <button
        key="gp_id_00"
        type="button"
        className={`group-btn${groupChoice === '' ? ' selected' : ''}`}
        onClick={() => this.changeGroup('')}
      >
        全表示
      </button>,
    ];
    for (let i = 0; i < groupInfo.length; i += 1) {
      const { id = '', name = '' } = groupInfo[i];
      groupContent.push(
        <button
          key={`gp_id_${i}`}
          type="button"
          className={`group-btn${groupChoice === id ? ' selected' : ''}`}
          onClick={() => this.changeGroup(id)}
        >
          {name}
        </button>
      );
    }
    return <div className="group-btn-list">{groupContent}</div>;
  };

  // 一覧を作成する。
  createSendMailList = (tmpMailList, insertCode, accountInfo, maxFlag, groupInfo) => {
    const sendMailList = [];

    const max = maxFlag ? tmpMailList.length : tmpMailList.length - 1;

    for (let i = 0; i < max; i += 1) {
      sendMailList.push(
        <SendTableRow
          data={tmpMailList[i]}
          insertCode={insertCode}
          accountInfo={accountInfo}
          groupInfo={groupInfo}
          key={`list_${commons.randomNum()}`}
        />
      );
    }
    return sendMailList;
  };

  // ページ送りの処理
  changePage = async (kind) => {
    const {
      dispNumUser,
      dispSkip,
      lgCd,
      insertCode = [],
      accountInfo = '',
      srcObj,
      groupChoice,
      groupInfo,
    } = this.state;
    const tmpSkip = dispSkip + dispNumUser * kind;

    const resData = await this.getData(
      tmpSkip,
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      srcObj,
      groupChoice,
      groupInfo
    );
    this.setState({ dispSkip: tmpSkip, ...resData });
  };

  // ページ送りの処理
  getData = async (
    skip,
    dispNumUser,
    lgCd,
    insertCode,
    accountInfo,
    srcObj,
    groupChoice,
    groupInfo
  ) => {
    // メール配信情報を取得する。
    const sendMail = await axios
      .post(`${API_PATH}/v/safety`, { lgCd, limit: dispNumUser + 1, skip, ...srcObj, groupChoice })
      .then((res) => res.data)
      .catch(() => {
        window.alert('データの取得に失敗しました。');
        return [];
      });

    const maxFlag = sendMail.length <= dispNumUser;
    const dispList = this.createSendMailList(sendMail, insertCode, accountInfo, maxFlag, groupInfo);

    return { maxFlag, dispList };
  };

  onClickBtnMove = (path) => {
    const { cryptUrl } = this.state;
    const { history } = this.props;
    history.push({ pathname: `${path}/${cryptUrl}` });
  };

  searchData = async () => {
    const {
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      srcTitle,
      srcStDate,
      srcEdDate,
      groupChoice,
      groupInfo,
    } = this.state;

    const srcObj = { srcTitle, srcStDate, srcEdDate };
    const resData = await this.getData(
      0,
      dispNumUser,
      lgCd,
      insertCode,
      accountInfo,
      srcObj,
      groupChoice,
      groupInfo
    );
    this.setState({ dispSkip: 0, srcObj, ...resData });
  };

  render() {
    const {
      siteName = '',
      dispNumUser,
      footer = '',
      dispList = [],
      dispSkip,
      accountInfo,
      maxFlag,
      groupInfo = [],
      groupChoice = '',
      clearKey = '',
    } = this.state;

    if (footer === '') return true;

    if (siteName === '') return null;

    const { group_flag: groupFlag = '' } = accountInfo;

    // グループの選択欄を作成する。
    const groupContent = groupFlag ? this.createGroupContent(groupInfo, groupChoice) : null;

    const pageMoveContent = (
      <div className="mt20" style={{ textAlign: 'center' }}>
        <button
          type="button"
          className="btnAtag mr10"
          disabled={dispSkip === 0}
          onClick={() => this.changePage(-1)}
        >
          {`< 前の${dispNumUser}件`}
        </button>
        {dispSkip / dispNumUser + 1}ページ目
        <button
          type="button"
          className="btnAtag ml10"
          disabled={maxFlag}
          onClick={() => this.changePage(1)}
        >
          {`次の${dispNumUser}件 >`}
        </button>
      </div>
    );

    return (
      <div id="safety-container">
        <div className="safety-back">
          <div className="safety-title">{siteName}</div>
          <div className="safety-content">
            <div className="safety-top">
              これまでに、当システムより配信されたメールを参照することができます。
            </div>
            <div className="search-box">
              <input
                className="mr10 mt10"
                type="text"
                size="25"
                placeholder="メール件名"
                key={`clear_title_${clearKey}`}
                onBlur={(e) => {
                  this.setState({ srcTitle: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    this.setState({ srcTitle: e.target.value }, () => this.searchData());
                  }
                }}
              />
              <input
                className="mt10"
                type="date"
                key={`clear_stdate_${clearKey}`}
                onBlur={(e) => {
                  this.setState({ srcStDate: e.target.value });
                }}
              />
              &nbsp;~&nbsp;
              <input
                className="mr20 mb10"
                type="date"
                key={`clear_edDate_${clearKey}`}
                onBlur={(e) => {
                  this.setState({ srcEdDate: e.target.value });
                }}
              />
              <button className="btn btnSearchMail" type="submit" onClick={() => this.searchData()}>
                検索
              </button>
              <button className="btn btnAtag" type="button" onClick={() => this.clearData()}>
                クリア
              </button>
            </div>
            {groupContent}
            {dispList.length === 0 ? (
              <div className="txtCenter mt10 mb20">条件に一致するメールは存在しませんでした。</div>
            ) : (
              <div>
                {pageMoveContent}
                <div className="safety-exposition mt10">
                  <table className="safety_table">
                    <thead>
                      <tr>
                        <th>配信日</th>
                        <th>メール件名</th>
                        {groupFlag ? <th className="hide-col">配信先</th> : null}
                      </tr>
                    </thead>
                    <tbody>{dispList}</tbody>
                  </table>
                </div>
                {pageMoveContent}
              </div>
            )}
            <div className="safety-fot">
              <button
                type="button"
                className="btnAtag mt20"
                onClick={() => {
                  this.onClickBtnMove('../home');
                }}
              >
                トップページに戻る
              </button>
              {footer}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

BackNumber.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(BackNumber);
